var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFonts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 510 510"
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5a5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#444"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__d",
    x1: 84.312,
    x2: 178.78,
    y1: 226.733,
    y2: 338.303,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#433f43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a1a1a"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__e",
    x1: 174.67,
    x2: 174.67,
    y1: 365.302,
    y2: 459.489,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__b"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__f",
    x1: 342.4,
    x2: 297.926,
    y1: 445.435,
    y2: 426.599,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__b"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__g",
    x1: 304.954,
    x2: 277.746,
    y1: 389.469,
    y2: 335.751,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__b"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__h",
    x1: 177.235,
    x2: 116.657,
    y1: 359.112,
    y2: 359.112,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__b"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__i",
    x1: 244.071,
    x2: 380.886,
    y1: 301.822,
    y2: 479.356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a8d3d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#596c76",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#596c76"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__j",
    x1: 300.432,
    x2: 362.325,
    y1: 393.799,
    y2: 350.637,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__c"
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__k",
    x1: 319.727,
    x2: 319.727,
    y1: 428.213,
    y2: 538.535,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__c"
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__l",
    x1: 211.962,
    x2: 227.31,
    y1: -18.711,
    y2: 115.933,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__m",
    x1: 134.484,
    x2: 149.832,
    y1: -9.88,
    y2: 124.764,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__n",
    x1: 57.007,
    x2: 72.355,
    y1: -1.048,
    y2: 133.596,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__o",
    x1: 366.917,
    x2: 382.265,
    y1: -36.375,
    y2: 98.269,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__p",
    x1: 289.439,
    x2: 304.787,
    y1: -27.543,
    y2: 107.101,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__q",
    x1: 409.409,
    x2: 424.757,
    y1: -41.218,
    y2: 93.426,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__r",
    x1: 14.514,
    x2: 29.862,
    y1: 3.796,
    y2: 138.44,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__s",
    x1: 386.674,
    x2: 514.342,
    y1: 237.188,
    y2: 304.858,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__t",
    x1: 354.198,
    x2: 481.866,
    y1: 298.458,
    y2: 366.128,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__u",
    x1: 321.722,
    x2: 449.389,
    y1: 359.727,
    y2: 427.398,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__v",
    x1: 419.151,
    x2: 546.819,
    y1: 175.918,
    y2: 243.589,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__w",
    x1: 451.627,
    x2: 579.295,
    y1: 114.648,
    y2: 182.319,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__x",
    x1: 476.386,
    x2: 604.054,
    y1: 67.938,
    y2: 135.609,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "fonts_svg__y",
    x1: 296.963,
    x2: 424.631,
    y1: 406.437,
    y2: 474.108,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#fonts_svg__a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__d)",
    d: "M8.917 444.698c0-1.712.571-3.994 1.142-6.277L116.186 90.37c6.277-19.97 31.952-29.67 58.199-29.67 26.246 0 51.922 9.7 58.198 29.67l106.698 348.052c.571 2.283 1.141 4.565 1.141 6.277 0 21.111-32.523 36.517-57.057 36.517-14.264 0-25.676-4.565-29.099-16.547l-19.4-71.322H114.474l-19.399 71.322c-3.424 11.982-14.835 16.547-29.099 16.547-24.536-.001-57.059-15.406-57.059-36.518zm207.12-119.821l-41.652-152.915-41.652 152.915z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__e)",
    d: "M132.732 324.877H44.68L10.059 438.422c-.571 2.283-1.142 4.565-1.142 6.277 0 21.111 32.523 36.517 57.058 36.517 14.265 0 25.676-4.565 29.099-16.547l19.399-71.322h120.392l19.4 71.322c3.423 11.982 14.835 16.547 29.099 16.547 24.534 0 57.057-15.406 57.057-36.517 0-1.712-.57-3.994-1.141-6.277l-34.808-113.545h-88.436z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__f)",
    d: "M282.962 436.251c0 18.432 12.221 34.003 29.001 39.069 15.625-6.354 28.46-17.361 28.46-30.622 0-1.712-.57-3.994-1.141-6.277l-13.154-42.91a41.692 41.692 0 00-2.353-.072c-22.541.001-40.813 18.273-40.813 40.812z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__g)",
    d: "M323.774 387.836l-31.543-102.894-53.395 53.394 49.499 49.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__h)",
    d: "M132.732 324.877l-18.258 68.47h120.391l-18.828-68.47z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__i)",
    d: "M312.075 267.096c-36.535 0-84.424 16.292-84.424 39.496 0 17.774 8.887 38.015 25.673 38.015 13.33 0 17.28-16.292 57.764-16.292 28.141 0 37.028 19.748 37.028 36.534v4.937h-17.774c-68.131 0-115.527 16.293-115.527 74.55 0 44.927 29.128 65.663 63.195 65.663 34.559 0 57.27-18.761 75.043-39.496v10.862c0 13.33 14.811 23.698 34.066 23.698 21.723 0 37.521-10.368 37.521-23.698V363.863c0-49.864-31.598-96.767-112.565-96.767zm36.04 141.694c0 25.179-21.723 45.421-37.028 45.421-11.355 0-19.255-6.418-19.255-20.736 0-23.698 26.166-26.66 54.308-26.66h1.975z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__j)",
    d: "M293.375 443.075c-.995-2.685-1.542-5.868-1.542-9.599 0-23.698 26.166-26.66 54.308-26.66h1.975v-37.028h-17.774c-67.634 0-114.825 16.063-115.511 73.288h78.544z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__k)",
    d: "M348.115 406.815v1.975c0 25.179-21.723 45.421-37.028 45.421-11.355 0-19.255-6.418-19.255-20.736 0-23.698 26.166-26.66 54.308-26.66H224.051c-5.995 9.95-9.237 22.301-9.237 37.522 0 44.927 29.128 65.663 63.195 65.663 34.559 0 57.27-18.761 75.043-39.496v10.862c0 13.33 14.811 23.698 34.066 23.698 21.723 0 37.521-10.368 37.521-23.698v-74.55h-76.524z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__l)",
    d: "M232.475 15.697h-31.394a7.848 7.848 0 100 15.696h31.394a7.848 7.848 0 100-15.696z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__m)",
    d: "M153.991 15.697h-31.394a7.848 7.848 0 100 15.696h31.394a7.848 7.848 0 100-15.696z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__n)",
    d: "M75.507 15.697H44.113a7.848 7.848 0 100 15.696h31.394a7.848 7.848 0 100-15.696z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__o)",
    d: "M389.444 15.697H358.05a7.848 7.848 0 100 15.696h31.394a7.848 7.848 0 100-15.696z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__p)",
    d: "M310.959 15.697h-31.394a7.848 7.848 0 100 15.696h31.394a7.848 7.848 0 100-15.696z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__q)",
    d: "M416.791 0a7.848 7.848 0 00-7.848 7.848v31.394a7.848 7.848 0 1015.696 0V7.848A7.847 7.847 0 00416.791 0z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__r)",
    d: "M16.766 0a7.848 7.848 0 00-7.848 7.848v31.394a7.848 7.848 0 1015.696 0V7.848A7.848 7.848 0 0016.766 0z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__s)",
    d: "M485.386 269.653a7.848 7.848 0 10-15.696 0v31.394a7.848 7.848 0 1015.696 0z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__t)",
    d: "M485.386 348.137a7.848 7.848 0 10-15.696 0v31.394a7.848 7.848 0 1015.696 0z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__u)",
    d: "M477.538 418.773a7.848 7.848 0 00-7.848 7.848v31.394a7.848 7.848 0 1015.696 0v-31.394a7.848 7.848 0 00-7.848-7.848z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__v)",
    d: "M485.386 191.169a7.848 7.848 0 10-15.696 0v31.394a7.848 7.848 0 1015.696 0z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__w)",
    d: "M485.386 112.685a7.848 7.848 0 10-15.696 0v31.394a7.848 7.848 0 1015.696 0z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__x)",
    d: "M461.841 76.397h31.394a7.848 7.848 0 100-15.696h-31.394a7.848 7.848 0 100 15.696z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#fonts_svg__y)",
    d: "M493.234 494.303H461.84a7.848 7.848 0 100 15.696h31.394a7.848 7.848 0 100-15.696z"
  })));
}
export default __webpack_public_path__ + "static/fonts.3898a11a.svg";
export { SvgFonts as ReactComponent };